import React from "react";
import {
  Checkbox as MUICheckbox,
  FormControlLabel,
  Typography,
} from "@mui/material";

interface CheckboxProps {
  isChecked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  labelPlacement?: "start" | "end" | "top" | "bottom";
}

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked,
  onChange,
  label,
  disabled = false,
  labelPlacement = "end",
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked); // Notify parent of state change
  };

  return (
    <FormControlLabel
      control={
        <MUICheckbox
          style={{ padding: "4px" }}
          size="small"
          checked={isChecked}
          onChange={handleChange}
        />
      }
      label={
        <Typography variant="body2" style={{ fontWeight: 400 }}>
          {label}
        </Typography>
      }
      disabled={disabled}
      labelPlacement={labelPlacement}
    />
  );
};

export default Checkbox;
